import React from 'react';
import css from './SectionOfferingsForm.module.css';
import { FieldCurrencyInput } from '../../../components';
import appSettings from '../../../config/settings';
import { useConfiguration } from '../../../context/configurationContext';
const PriceInputField = ({ formId }) => {
  const config = useConfiguration();
  const marketplaceCurrency = config.currency;
  return (
    <div className={css.fieldGroup}>
      <FieldCurrencyInput
        id={`${formId}price`}
        name="price"
        className={css.input}
        label={'Price'}
        currencyConfig={appSettings.getCurrencyFormatting(marketplaceCurrency)}
        disabled
      />
    </div>
  );
};

export default PriceInputField;
